import type { Locale } from '@/domains/core/localization/interfaces/Locale';
import type { Platform } from '@/domains/core/settings/interfaces/Platform';

const platformToLocaleMap = {
  es: 'es',
  fr: 'fr',
  gb: 'en',
  de: 'de',
  it: 'it',
} as { [key in Platform]: Locale };

export function getPlatformLocale(platform: Platform): Locale {
  return platformToLocaleMap[platform];
}
